<template>
  <div>
    <b-container>
      <b-row
        align-h="center"
        class="b-tabs"
      >
        <b-col
          cols="2"
          class="text-center"
        >
          <label
            :class="linkClass(0)"
            @click="didSelect(0)"
          >停线(Andon)</label>
        </b-col>
        <b-col
          cols="2"
          class="text-center"
        >
          <label
            :class="linkClass(1)"
            @click="didSelect(1)"
          >故障报修</label>
        </b-col>
        <b-col
          cols="2"
          class="text-center"
        >
          <label
            :class="linkClass(2)"
            @click="didSelect(2)"
          >班末总结</label>
        </b-col>
        <b-col
          cols="2"
          class="text-center"
        >
          <label
            :class="linkClass(3)"
            @click="didSelect(3)"
          >先进先出</label>
        </b-col>
        <b-col
          cols="2"
          class="text-center"
        >
          <label
            :class="linkClass(4)"
            @click="didSelect(4)"
          >预防性维护</label>
        </b-col>
      </b-row>
    </b-container>
    <div>
      <div
        class="div-content"
        v-if="show === 0"
      >
        <b-row align-h="center">
          <b-col cols="9">
            <div>
              <img
                class="top-img"
                src="@/assets/images/module-stop-topimg_1.png"
              >
              <b-row align-h="center">
                <b-col cols="6">
                  <p class="text-center p-title">停线求助</p>
                  <img
                    class="p-title-bg"
                    src="@/assets/images/module-stop-title_bg.png"
                  >
                  <p class="text-center p-desc">生产非预期性中断时，快速发出求助信号（ANDON），设置解决问题时限超时自动报警，提醒管理层及时关注。提升跨部门沟通效率，详细记录解决问题的过程和原因分析，为问题追溯提供可靠依据。</p>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
        <!-- <img class="footer-img" src="@/assets/images/module-stop-footerimg_1.png"> -->

      </div>
      <div
        class="div-content"
        v-else-if="show === 1"
      >
        <b-row align-h="center">
          <b-col cols="9">
            <div>
              <img
                class="top-img"
                src="@/assets/images/module-stop-topimg_2.png"
              >
              <b-row align-h="center">
                <b-col cols="6">
                  <p class="text-center p-title">故障报修</p>
                  <img
                    class="p-title-bg"
                    src="@/assets/images/module-stop-title_bg.png"
                  >
                  <p class="text-center p-desc">生产非预期性中断时，快速发出求助信号（ANDON），设置解决问题时限超时自动报警，提醒管理层及时关注。提升跨部门沟通效率，详细记录解决问题的过程和原因分析，为问题追溯提供可靠依据。</p>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
        <!-- <img
          class="footer-img"
          src="@/assets/images/module-stop-footerimg_2.png"
        > -->
      </div>
      <div
        class="div-content"
        v-else-if="show === 2"
      >
        <b-row align-h="center">
          <b-col cols="9">
            <div>
              <img
                class="top-img"
                src="@/assets/images/module-stop-topimg_3.png"
              >
              <b-row align-h="center">
                <b-col cols="6">
                  <p class="text-center p-title">班末总结</p>
                  <img
                    class="p-title-bg"
                    src="@/assets/images/module-stop-title_bg.png"
                  >
                  <p class="text-center p-desc">生产非预期性中断时，快速发出求助信号（ANDON），设置解决问题时限超时自动报警，提醒管理层及时关注。提升跨部门沟通效率，详细记录解决问题的过程和原因分析，为问题追溯提供可靠依据。</p>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
        <!-- <img
          class="footer-img"
          src="@/assets/images/module-stop-footerimg_3.png"
        > -->
      </div>
      <div
        class="div-content"
        v-else-if="show === 3"
      >
        <b-row align-h="center">
          <b-col cols="9">
            <div>
              <img
                class="top-img"
                src="@/assets/images/module-stop-topimg_1.png"
              >
              <b-row align-h="center">
                <b-col cols="6">
                  <p class="text-center p-title">先进先出</p>
                  <img
                    class="p-title-bg"
                    src="@/assets/images/module-stop-title_bg.png"
                  >
                  <p class="text-center p-desc">生产非预期性中断时，快速发出求助信号（ANDON），设置解决问题时限超时自动报警，提醒管理层及时关注。提升跨部门沟通效率，详细记录解决问题的过程和原因分析，为问题追溯提供可靠依据。</p>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
        <!-- <img
          class="footer-img"
          src="@/assets/images/module-stop-footerimg_1.png"
        > -->
      </div>
      <div
        class="div-content"
        v-else-if="show === 4"
      >
        <b-row align-h="center">
          <b-col cols="9">
            <div>
              <img
                class="top-img"
                src="@/assets/images/module-stop-topimg_5.png"
              >
              <b-row align-h="center">
                <b-col cols="9">
                  <p class="text-center p-title">预防性维护</p>
                  <img
                    class="p-title-bg"
                    src="@/assets/images/module-stop-title_bg.png"
                  >
                  <p class="text-center p-desc">生产非预期性中断时，快速发出求助信号（ANDON），设置解决问题时限超时自动报警，提醒管理层及时关注。提升跨部门沟通效率，详细记录解决问题的过程和原因分析，为问题追溯提供可靠依据。</p>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
        <!-- <img
          class="footer-img"
          src="@/assets/images/module-stop-footerimg_5.png"
        > -->
      </div>
      <div class="funs">
        <img
          class="footer-img"
          src="@/assets/images/function/funs.png"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModuleHeader",
  data() {
    return {
      show: 0,
    };
  },
  methods: {
    didSelect(ids) {
      // 取消先进先出响应
      if (ids === 3) {
        return;
      }
      this.show = ids;
    },
    linkClass(idx) {
      if (this.show === idx) {
        return ["label-did"];
      } else {
        return ["label"];
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.funs {
  width: 100%;
}

.b-tabs {
  box-shadow: 0rem 0.3rem 0.8rem 0rem rgba(2, 0, 0, 0.11);
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.label-did {
  color: #12b7f6;
  font-size: 1.3rem;
}

.label {
  color: #999999;
  font-size: 1.3rem;
}

.div-content {
  margin-top: 5rem;
  width: 100%;

  .top-img {
    width: 100%;
  }

  .p-title {
    margin-top: 4rem;
    font-size: 1.5rem;
    color: #333333;
  }

  .p-title-bg {
    margin-top: -6rem;
    margin-left: 50%;
    transform: translateX(-50%);
  }

  .p-desc {
    margin-top: 2rem;
    fontsize: 1.1rem;
    color: #333333;
  }
}

.footer-img {
  width: 100%;
  margin-top: 5rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/module/components/ModuleContent.vue